import { useMemo } from 'react';
import { IntlShape } from 'react-intl';

export type ControlsProps = {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
    number?: boolean;
    minValue?: number | string;
    maxValue?: number | string;
    email?: boolean;
    url?: boolean;
    date?: boolean;
};

/***
 * Format
 * @todo trad
 */
const required = (intl: IntlShape) => (value: boolean) =>
    !value || (value && Array.isArray(value) && !value.length)
        ? intl.formatMessage({
              id: 'GLOBAL_Form_Controls_Required',
          })
        : undefined;
const maxLength = (intl: IntlShape, max: number) => (value: string) =>
    value && value.length > max
        ? intl.formatMessage(
              {
                  id: 'GLOBAL_Form_Controls_MaxLength',
              },
              { max },
          )
        : undefined;

const minLength = (intl: IntlShape, min: number) => (value: string) =>
    value && value.length < min
        ? intl.formatMessage(
              {
                  id: 'GLOBAL_Form_Controls_MinLength',
              },
              { min },
          )
        : undefined;

const number = (intl: IntlShape) => (value: any) =>
    // TODO : doesn't work !!
    value && isNaN(Number(value))
        ? intl.formatMessage({
              id: 'GLOBAL_Form_Controls_Number',
          })
        : undefined;

const minValue = (intl: IntlShape, min: number | string) => (value: number) =>
    value && value < +min
        ? intl.formatMessage(
              {
                  id: 'GLOBAL_FORM_CONTROLS_MinValue',
              },
              { min },
          )
        : undefined;

const maxValue = (intl: IntlShape, max: number | string) => (value: number) =>
    value && value > +max
        ? intl.formatMessage(
              {
                  id: 'GLOBAL_Form_Controls_MaxValue',
              },
              { max },
          )
        : undefined;

const email = (intl: IntlShape) => (value: string) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? intl.formatMessage({
              id: 'ERROR_Mail_Invalid',
          })
        : undefined;

const url = (intl: IntlShape) => (value: string) =>
    // eslint-disable-next-line no-useless-escape
    value && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.test(value)
        ? intl.formatMessage({
              id: 'GLOBAL_Form_Controls_Url',
          })
        : undefined;

const date = (intl: IntlShape) => (value: string) =>
    value && !/^\d{2,2}\/\d{2,2}\/\d{4,4}$/i.test(value)
        ? intl.formatMessage({
              id: 'GLOBAL_Form_Controls_Date',
          })
        : undefined;
/**
 * @deprecated Use react-hook-form instead of redux-form
 */
export const getControls = (props: ControlsProps & { intl: IntlShape }) => {
    const controls = [];
    if (props.required) {
        controls.push(required(props.intl));
    }
    if (props.minLength) {
        controls.push(minLength(props.intl, props.minLength));
    }
    if (props.maxLength) {
        controls.push(maxLength(props.intl, props.maxLength));
    }
    if (props.number) {
        controls.push(number(props.intl));
    }
    if (props.date) {
        controls.push(date(props.intl));
    }
    if (props.minValue) {
        controls.push(minValue(props.intl, props.minValue));
    }
    if (props.maxValue) {
        controls.push(maxValue(props.intl, props.maxValue));
    }
    if (props.email) {
        controls.push(email(props.intl));
    }
    if (props.url) {
        controls.push(url(props.intl));
    }
    return controls;
};

/**
 * @deprecated Use react-hook-foorm instead of redux-form
 */
export const useControls = (props: ControlsProps & { intl: IntlShape }) => {
    const { required, minLength, maxLength, number, minValue, maxValue, email, url } = props;
    const validate = useMemo(
        () => getControls({ ...props }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [required, minLength, maxLength, number, minValue, maxValue, email, url],
    );
    return validate;
};
